import { useEffect, useState } from "react";
import useFetch from "../hooks/useFetch"
import { FacultyType } from "../Utils/DataType";

export default function ContactFaculty() {
    const dataFaculty = useFetch('faculties', false);
    const [listFaculty, setList] = useState<FacultyType[]>([]);
    useEffect(() => {
        console.log(dataFaculty.response);
        if (dataFaculty.response) setList(dataFaculty.response)
    }, [dataFaculty.response]);

    useEffect(() => {
        console.log(listFaculty);
    }, [listFaculty])
    return (
        <div>
            <section id="room" className="computer-room">
                <table className="table-computer-room">
                    <tr>
                        <th style={{ width: '30%' }}>Khoa</th>
                        <th>Địa chỉ email</th>
                        <th>Số điện thoại</th>
                        <th>Địa chỉ Văn phòng</th>
                    </tr>
                    <tbody>
                        {listFaculty && listFaculty.map((item, index) => {
                            return (
                                <tr>
                                    <td style={{ textAlign: 'left' }}>{item.name}</td>
                                    <td>{item.email ? item.email : 'Chưa cập nhật'}</td>
                                    <td>{item.phone ? item.phone : 'Chưa cập nhật'}</td>
                                    <td>Chưa cập nhật</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </section>
        </div>
    )
}